var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOkx = function SvgOkx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "okx_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 2500 2500"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".okx_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "okx_svg__Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "okx_svg___2187381323856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2500v2500H0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1463 1015h-404c-17 0-31 14-31 31v404c0 17 14 31 31 31h404c17 0 31-14 31-31v-404c0-17-14-31-31-31M996 549H592c-17 0-31 14-31 31v404c0 17 14 31 31 31h404c17 0 31-14 31-31V580c0-17-14-31-31-31M1930 549h-404c-17 0-31 14-31 31v404c0 17 14 31 31 31h404c17 0 31-14 31-31V580c0-17-14-31-31-31M996 1482H592c-17 0-31 14-31 31v404c0 17 14 31 31 31h404c17 0 31-14 31-31v-404c0-17-14-31-31-31M1930 1482h-404c-17 0-31 14-31 31v404c0 17 14 31 31 31h404c17 0 31-14 31-31v-404c0-17-14-31-31-31",
    className: "okx_svg__st1"
  })))));
};
export { SvgOkx as ReactComponent };